import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
export function useDebounce(value, t0) {
  const $ = _c(4);
  const delay = t0 === undefined ? 250 : t0;
  const [debouncedValue, setDebouncedValue] = React.useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const timer = globalThis.setTimeout(() => setDebouncedValue(value), delay);
      return () => globalThis.clearTimeout(timer);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  React.useEffect(t1, t2);
  return debouncedValue;
}